import(/* webpackMode: "eager" */ "/var/www/sahha/apps/web/src/app/global-error.tsx");
